
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profil/bestillingshistorik",
      function () {
        return require("private-next-pages/profil/bestillingshistorik.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profil/bestillingshistorik"])
      });
    }
  